const TENANT_KEY = "tenantId";

export function setTenantId(tenantId) {
	if (tenantId && typeof tenantId === "string" && tenantId.trim().length > 0) {
		localStorage.setItem(TENANT_KEY, tenantId.trim());
		return;
	}
	localStorage.removeItem(TENANT_KEY);
}

export function getTenantId() {
	return localStorage.getItem(TENANT_KEY) || null;
}

/** Default tenant for Auth microservice login/register (Swagger LoginRequest.tenant_id). */
export function getDefaultTenantId() {
	const fromStorage = getTenantId();
	if (fromStorage) return fromStorage;
	const fromEnv = String(process.env.REACT_APP_DEFAULT_TENANT_ID || "").trim();
	if (fromEnv) return fromEnv;
	// Stage/dev default (team Swagger example). Override via REACT_APP_DEFAULT_TENANT_ID in .env
	return "highwatch-demo";
}

export function clearTenantId() {
	localStorage.removeItem(TENANT_KEY);
}

export { TENANT_KEY };



